/* unplugin-vue-components disabled */
import Column from 'primevue/column'
import {DataTable} from 'components/data-table'
import AddModal from './add-modal.vue'
import $companies from 'stores/companies'

const LIMIT = 20

export default {
  components: {
    AddModal,
    DataTable,
    Column
  },
  props: {
    tenant: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      load_params: {skip: 0, limit: LIMIT, filter: '', user_id: this.user.id},
    }
  },
  computed: {
    total(){
      return $companies.total
    },
    view_items(){
      return $companies.view_items
    },
    view_total(){
      return $companies.view_total
    },
    refreshing() {
      return $companies.loading
    },
    highlight () {
      return this.load_params.filter
    }
  },
  async mounted() {
    this.loading = true
    await $companies.load(this.load_params)
    this.loading = false
  },
  methods: {
    async onPage(ev){
      this.load_params = {...this.load_params, skip: ev.first, limit: ev.rows}
      await $companies.load(this.load_params)
    },
    async onCopyId(id) {
      await $utils.copyText(id)
    },
    async onSearch(filter){
      if (this.load_params.filter === filter) return
      this.load_params = {skip: 0, limit: LIMIT, filter, user_id: this.user.id}
      await $companies.load(this.load_params)
      this.$refs.search.focus()
    },
    onAddCompany() {
      this.$refs.addModal.open(this.user.id)
    },
    async onNewCompany(data) {
      const payload = {
        linkedin_id: data.chosen_company.linkedin_id,
        user_id: this.user.id,
      }

      try {
        await $companies.newCompany(payload)
        await $companies.load(this.load_params)
        $utils.toasts.success('User company added successfully')
      }
      catch(err) {
        $utils.toasts.error(`Failed to add company: ${err}`)
      }
      this.$refs.addModal.close(true)
    },
    async onRemoveCompany(id) {
      const comp = await $companies.getCompany(id)
      await comp.drop(this.user.id)
      await $companies.load(this.load_params)
    },
  }
}
